import './SegmentEditor.scss';
import { ByzzerInput } from '@/components/form';
import {ByzzerButton} from '@byzzer/ui-components';
import React, { useEffect, useState } from 'react';
import { SegmentSelector } from './SegmentSelector';
import { SegmentPreview } from './SegmentPreview';

interface Char {
    characteristic: string;
    characteristicDisplayValue?: string;
    condition: string;
    value: any[];
    isCustom?: boolean;
    and?: any;
}

type SegmentEditorPropsType = {
    index: any;
    onCreateSegment: any;
    segment: any;
    characteristicsForCategories: any;
    characteristicOptions: any;
    selectedCategories: any;
    cancelable: boolean;
    onCancel: any;
    setLoading: any;
}

const baseClassName = 'segment-editor';

export function SegmentEditor({
    index,
    onCreateSegment,
    segment,
    selectedCategories,
    cancelable = true,
    onCancel,
    setLoading,
}: SegmentEditorPropsType) {
    const [char, setChar] = useState<Char[]>([{ characteristic: '', condition: 'is', value: [] }]);
    const [segmentName, setSegmentName] = useState('');

    useEffect(() => {
        if (segment?.char) {
            setChar(
                segment.char.map((item) => ({
                    characteristic: item.characteristic,
                    characteristicDisplayValue: item.characteristicDisplayValue,
                    condition: item.condition,
                    value: item.value,
                    isCustom: item.isCustom,
                    and: item.and,
                }))
            );
        } else {
            setChar([{ characteristic: '', condition: 'is', value: [] }]);
        }
        setSegmentName(segment?.name);
    }, [segment]);

    const addCondition = () => {
        const newChar = { characteristic: '', condition: 'is', value: [], and: 'and' };
        setChar(prevChar => [...prevChar, newChar]);
    };
    const onRowChange = (index, condition) => {
        setChar(prevChar =>
            prevChar.map((item, i) =>
                i === index
                    ? {
                        ...item,
                        characteristic: condition?.characteristic ?? '',
                        characteristicDisplayValue: condition?.characteristicDisplayValue ?? '',
                        condition: condition?.condition ?? 'is',
                        value: condition?.value ?? [],
                        isCustom: condition?.isCustom ?? false,
                    }
                    : item
            )
        );
    };
    const onToggleChange = (index, value) => {
        setChar(prevChar => 
            prevChar.map((item, i) => 
                i === index ? { ...item, and: value } : item
            )
        );
    };
    const onRemoveSelector = (index, element) => {
        setChar(prevChar => prevChar.filter((_, i) => i !== index));
    };
    const checkAllChar = () => {
        let result = false;
        char.forEach((item) => {
            if (!item.characteristic || !item.condition || !item.value?.length) {
                result = true;
            }
        });
        return result;
    };

    function onCancelClick() {
        onCancel?.();
    }

    return (
        <div className={baseClassName}>
            {/* @ts-ignore */}
            <ByzzerInput
                label={<>Segment {index + 1}</>}
                className={`${baseClassName}__name`}
                type={'text'}
                placeholder={'Enter label for segment'}
                value={segmentName}
                onChange={(e) => setSegmentName(e.target.value.trim())}
                variant={'secondary'}
            />
            {char.map((item, index) => (
                <SegmentSelector
                    index={index}
                    char={item}
                    key={index}
                    removable={index > 0}
                    includeToggle={index > 0}
                    selectedCategories={selectedCategories}
                    onRowChange={onRowChange}
                    onToggleChange={(value) => onToggleChange(index, value)}
                    onRemoveSelector={onRemoveSelector}
                    variant={'secondary'}
                />
            ))}

            <div className={`${baseClassName}__add-condition`} onClick={addCondition}>
                + Add another condition
            </div>

            <SegmentPreview char={char} />

            <div className={`${baseClassName}__actions`}>
                {cancelable && (
                    <ByzzerButton onClick={onCancelClick} type={'negative'}>
                        Cancel
                    </ByzzerButton>
                )}
                <ByzzerButton
                    disabled={checkAllChar() || !segmentName}
                    onClick={() => onCreateSegment({ name: segmentName, char: char })}
                >
                    {segment ? 'Save' : 'Create'} Segment
                </ByzzerButton>
            </div>
        </div>
    );
}

export default SegmentEditor;
